var map = {
	"./Seam_3122.jpg": 680,
	"./Seam_3142.jpg": 681,
	"./Seam_4342.jpg": 682,
	"./Seam_4510.jpg": 683,
	"./Seam_4521.jpg": 684,
	"./Seam_4540.jpg": 685,
	"./Seam_4552.jpg": 686,
	"./Seam_4631.jpg": 687,
	"./Seam_5043.jpg": 688,
	"./Seam_5731.jpg": 689,
	"./Seam_6720.jpg": 690,
	"./Seam_6722.jpg": 691,
	"./Seam_6750.jpg": 692,
	"./Seam_6920.jpg": 693,
	"./Seam_8000.jpg": 694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;